import { atom } from 'jotai'

import {
  type DetailInfo,
  type DispatchGroupInfo
} from '@/features/vehicle-dispatch-boards/formatters'

/**
 * ドラッグ中の配車グループ（束ね親矢羽根の一括時刻シフト）
 */
export type DraggingDispatchGroup = {
  group: DispatchGroupInfo
  // グループに属する全明細（元の startAt/endAt。delta 適用の基準にする）
  groupDetails: DetailInfo[]
  planSlotId: number | null
  // プレビュー用: グループ全体の代表時間帯（from〜to）を delta シフトした値
  range: { startAt: string; endAt: string } | null
  // 全明細に一律で加える相対シフト量（分）
  deltaMinutes: number | null
}

export const draggingDispatchGroupAtom = atom<DraggingDispatchGroup | null>(
  null
)

draggingDispatchGroupAtom.debugLabel = 'draggingDispatchGroupAtom'
